import { Attributes, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

@NeoModel
export default class DwtExemption extends TemporalEntity {
    static typeName = "DwtExemption";

    public dwtExemptionId: number = 0;

    @Attributes.Display("Code")
    @Rules.StringLength(1)
    @Rules.Required()
    public code: string = "";

    @Rules.Required()
    @Rules.StringLength(350)
    public description: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.code.length > 0 && !(/^[A-Z]$/.test(c.code)), "The DWT Exemption Code must be 1 uppercase alphabetical character");
    }

    public toString(): string {
        if (this.isNew || !this.code) {
            return "New DWT Exemption";
        } else {
            return this.code;
        }
    }
}